module.exports = __webpack_public_path__ + "static/media/img_passport_bg.c24591fd.svg";